import lexisLogo from 'assets/images/intro/LEXIS2_logo.png';
import { Typography } from '@mui/material';
import { IS_EFP } from 'config';

const isEFP = IS_EFP;

const HeaderLogoIcon = () => {
    return isEFP ? (
        <Typography variant='h5' component='div' sx={{ flexGrow: 1 }}>
            EFP W
        </Typography>
    ) : (
        <img src={lexisLogo} alt='Lexis' width='40' />
    );
};

export default HeaderLogoIcon;
